import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Shop from "../pages/shop/page";
import OfficialStore from "../pages/store/page";
import ProductPage from "../pages/product/page";
import CartPage from "../pages/cart/page";
import AdminPage from "../pages/admin/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/shop",
    element: <Shop />,
  },
  {
    path: "/shop/:categorySlug",
    element: <Shop />,
  },
  {
    path: "/shop/:categorySlug/:storeSlug",
    element: <OfficialStore />,
  },
  {
    path: "/product/:slug",
    element: <ProductPage />,
  },
  {
    path: "/cart",
    element: <CartPage />,
  },
  {
    path: "/admin",
    element: <AdminPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;